module.exports = __webpack_public_path__ + "img/play-btn.6c1f3e4a.svg";